var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_54_8345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_54_8345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.507 9.8782C20.6758 10.5576 20.7655 11.2683 20.7655 11.9999C20.7655 16.841 16.841 20.7655 11.9999 20.7655C7.15885 20.7655 3.23438 16.841 3.23438 11.9999C3.23438 7.15885 7.15885 3.23438 11.9999 3.23438C13.9473 3.23438 15.7464 3.86941 17.2013 4.9437",
    stroke: "white",
    strokeWidth: 0.96,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46094 10.4056C9.21299 12.2914 11.3061 14.5442 11.3061 14.5442C11.3061 14.5442 16.8819 9.34785 19.3052 7.08936",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d5736d1cdff91a1b44a54b86558b04fa.svg";
export { ForwardRef as ReactComponent };